export default __webpack_public_path__ + "static/media/decada-0060-0008-min.3d81ba10.jpg";